import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import Header from "./content/header"
import api from "../../services/api"
import JSONPretty from 'react-json-pretty';



class CategoriaAdmin extends Component {
state = {
  nome:null,
  logss:[],
  error:null,
  success:null
}



  async componentDidMount(){
   this.loadlogs();
  }


  async loadlogs () {
    const response = await api.post("/admin/logs/list");
    this.setState({ logss: response.data });
  }



 

  render() {
    return (
      <React.Fragment>
          <Header />
        <div class="container-fluid col-lg-10 ">     

       













    {/* Tables */}

    <table id="" class="table table-responsive" >
  <thead>
    <tr>
      <th scope="col" >Operador

      </th>
      <th scope="col" >Ação

      </th>
      <th scope="col">Log

      </th>
    </tr>
  </thead>
  <tbody>
  {this.state.logss.map(el => (
    <tr>
    <td>{el.operador}</td>
    <td>{el.contexto}</td>
    <td><JSONPretty id="json-pretty" data={el.log}></JSONPretty>
</td>
 
  </tr>
  ))}
    

   
  </tbody>

</table>

{/* FIm table */}


    </div>
      </React.Fragment>
       
    );
  }
}

export default withRouter(CategoriaAdmin);


// WEBPACK FOOTER //
// ./src/pages/Admin/logs.js